
import { APICall } from "@/config/NetworkUtility";
import { logApiError } from "../apiErrorLogger";


export const GetCompanyRequestDetail =
    async (companyId) => {

        try {

            if (!companyId) {
                throw new Error(
                    "Company ID is required"
                );
            }

            const url =
                `/v2/CompanySetup/GetCompanyRequestDetail?CompanyRequestId=${companyId}`;

            const result = await APICall(
                "get",
                null,
                url
            );

            if (
                result?.statuscode === 200 ||
                result?.statuscode === 201
            ) {

                return result?.data?.[0] || null;
            }

            return Promise.reject(result);

        } catch (error) {

            logApiError(error, {
                source: "company.service",
                endpoint:
                    "GetCompanyRequestDetail",
                method: "GET",
                url:
                    `/v2/CompanySetup/GetCompanyRequestDetail`,
                companyId,
            });

            return Promise.reject(error);
        }
    };

export const GetMasterCompanyDetail =
    async (companyId) => {

        try {

            if (!companyId) {
                throw new Error(
                    "Company ID is required"
                );
            }

            const url =
                `/v2/CompanySetup/MasterCompanyDetails?MasterCompanyId=${companyId}`;

            const result = await APICall(
                "get",
                null,
                url
            );

            if (
                result?.statuscode === 200 ||
                result?.statuscode === 201
            ) {

                return result?.data?.[0] || null;
            }

            return Promise.reject(result);

        } catch (error) {

            logApiError(error, {
                source: "company.service",
                endpoint:
                    "GetMasterCompanyDetail",
                method: "GET",
                url:
                    `/v2/CompanySetup/MasterCompanyDetails`,
                companyId,
            });

            return Promise.reject(error);
        }
    };